import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SkladPneu = {
	name: NAME,
	apiProvider,
	router,
};
